import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Main = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/profile');
    }
  }, [user, navigate]);

  return (
    <div className="bg-cover bg-center bg-no-repeat min-h-screen w-full"
    style={{backgroundImage: "url('/images/leelo_landing.jpg')" }}>
    <div className="flex flex-col justify-center items-center min-h-screen p-8 text-center relative">
      <div className="absolute top-6 right-8 z-10">
        <Link 
          to="/login" 
          className="text-white text-sm no-underline border-b border-dark-gray pb-0.5 transition-colors hover:text-vinous hover:border-vinous"
        >
          Login
        </Link>
      </div>
      
      <div className="mt-24">
        <img 
          src="/images/leelo_logo_transparent_cropped.png" 
          alt="Leelo Logo" 
          className="mx-auto mb-12 w-64 h-auto" 
        />
        
        <h1 className="max-w-[800px] mb-4 leading-relaxed text-white font-bold" style={{ fontSize: "1.75rem" }}>
          Your AI thought-partner—ready for solo brainstorming or group chats.
        </h1>
        
        <p className="max-w-[800px] mb-8 leading-relaxed text-white font-medium" style={{ fontSize: "1.125rem" }}>
          Text one-to-one to reflect and explore, or loop in friends so everyone can bounce ideas off an AI that listens, guides, and sparks fresh perspectives.
        </p>
        
        <div className="mb-8 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link 
            to="/signup" 
            className="bg-tropical-indigo text-white border-2 border-tropical-indigo rounded py-3 text-lg font-bold no-underline hover:opacity-90 transition-opacity w-[160px]"
          >
            Join
          </Link>
          <Link 
            to="/learn-more" 
            className="bg-white text-tropical-indigo border-2 border-tropical-indigo rounded py-3 text-lg font-bold no-underline hover:bg-tropical-indigo hover:text-white transition-colors w-[160px]"
          >
            Learn More
          </Link>
        </div>
      </div>
      
      <footer className="text-white text-xs text-center mt-auto">
        2025 © Wenzi, Inc. 
        <span className="mx-2">•</span> 
        <Link to="/privacy" className="text-white hover:underline">
          Privacy Policy
        </Link>
        <span className="mx-2">•</span> 
        <a 
          href="https://discord.gg/z859AyVU3R" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-white hover:underline"
        >
          Join our Discord
        </a>
      </footer>
    </div>
    </div>
  );
};

export default Main;
